import script from "./Camera.vue?vue&type=script&setup=true&lang=js"
export * from "./Camera.vue?vue&type=script&setup=true&lang=js"

import "./Camera.vue?vue&type=style&index=0&id=4b569fa4&lang=scss"

const __exports__ = script;

export default __exports__